import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";
import {MainMenuController} from "./MainMenuController";

export interface IIntroScreenControllerOptions
{
}

export class MainMenuContainerController extends AnimationBaseController {
    $model: GameModel;


    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("MainMenuContainer");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_MENU_SCREEN_JSON,
            libraryName: "main_menu_container",
            childControllers: {
                MainMenu:this.getMainMenuObject(),
            },
            modelWatch: {
                "showMainMenu": async (showMainMenuContainer: boolean) => {
                    if(showMainMenuContainer){
                        this.addChildController(this.getMainMenuObject(), "MainMenu");
                    }else{
                        await this.removeChildControllerByNameAsync("MainMenu");
                    }

                }
            }
        };
    }


    private getMainMenuObject(){
        this._gameLogic.showMainMenu();
        return {
            libraryName: "main_menu",
            view: MainMenuController,
            model: this.$model,
        }
    }

    protected onInitialize(): void {

    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

